// store/Automation/saga.js

import { call, all, put, takeLatest, takeEvery } from "redux-saga/effects";

import {
  AUTOMATION_SCENARIO_LIST,
  AUTOMATION_SCENARIO_STATUS_LIST,
  AUTOMATION_CANVAS,
  AUTOMATION_SCENARIO_CREATE,
  AUTOMATION_SCENARIO_UPDATE,
  AUTOMATION_SCENARIO_PUBLISH,
  AUTOMATION_SCENARIO_DUPLICATE,
  AUTOMATION_SCENARIO_DISABLE,
  AUTOMATION_SCENARIO_DELETE,
  AUTOMATION_NODE_CREATE,
  AUTOMATION_NODE_UPDATE,
  AUTOMATION_NODE_DELETE,
  AUTOMATION_LINK_CREATE,
  AUTOMATION_LINK_DELETE,
  AUTOMATION_BLOCK_CONFIG_FIELDS,
  AUTOMATION_NODE_CONFIG_SAVE,
  AUTOMATION_NODE_CONFIG_DELETE,
  AUTOMATION_DELAY_CREATE,
  AUTOMATION_DELAY_UPDATE,
  AUTOMATION_CONDITION_GROUP_CREATE,
  AUTOMATION_CONDITION_GROUP_UPDATE,
  AUTOMATION_CONDITION_GROUP_DELETE,
  AUTOMATION_CONDITION_RULE_CREATE,
  AUTOMATION_CONDITION_RULE_UPDATE,
  AUTOMATION_CONDITION_RULE_DELETE,
  AUTOMATION_EXECUTION_LIST,
  AUTOMATION_EXECUTION_DATA,
  AUTOMATION_EXECUTION_TRIGGER,
  AUTOMATION_EXECUTION_STATUS_LIST,
} from "./actionType";

import {
  automationScenarioListSuccess,
  automationScenarioListFailure,
  automationScenarioStatusListSuccess,
  automationScenarioStatusListFailure,
  automationCanvasSuccess,
  automationCanvasFailure,
  automationScenarioCreateSuccess,
  automationScenarioCreateFailure,
  automationScenarioUpdateSuccess,
  automationScenarioUpdateFailure,
  automationScenarioPublishSuccess,
  automationScenarioPublishFailure,
  automationScenarioDuplicateSuccess,
  automationScenarioDuplicateFailure,
  automationScenarioDisableSuccess,
  automationScenarioDisableFailure,
  automationScenarioDeleteSuccess,
  automationScenarioDeleteFailure,
  automationNodeCreateSuccess,
  automationNodeCreateFailure,
  automationNodeUpdateSuccess,
  automationNodeUpdateFailure,
  automationNodeDeleteSuccess,
  automationNodeDeleteFailure,
  automationLinkCreateSuccess,
  automationLinkCreateFailure,
  automationLinkDeleteSuccess,
  automationLinkDeleteFailure,
  automationBlockConfigFieldsSuccess,
  automationBlockConfigFieldsFailure,
  automationNodeConfigSaveSuccess,
  automationNodeConfigSaveFailure,
  automationNodeConfigDeleteSuccess,
  automationNodeConfigDeleteFailure,
  automationDelayCreateSuccess,
  automationDelayCreateFailure,
  automationDelayUpdateSuccess,
  automationDelayUpdateFailure,
  automationConditionGroupCreateSuccess,
  automationConditionGroupCreateFailure,
  automationConditionGroupUpdateSuccess,
  automationConditionGroupUpdateFailure,
  automationConditionGroupDeleteSuccess,
  automationConditionGroupDeleteFailure,
  automationConditionRuleCreateSuccess,
  automationConditionRuleCreateFailure,
  automationConditionRuleUpdateSuccess,
  automationConditionRuleUpdateFailure,
  automationConditionRuleDeleteSuccess,
  automationConditionRuleDeleteFailure,
  automationExecutionListSuccess,
  automationExecutionListFailure,
  automationExecutionDataSuccess,
  automationExecutionDataFailure,
  automationExecutionTriggerSuccess,
  automationExecutionTriggerFailure,
  automationExecutionStatusListSuccess,
  automationExecutionStatusListFailure,
} from "./action";

import {
  callAutomationScenarioListApi,
  callAutomationScenarioCreateApi,
  callAutomationScenarioUpdateApi,
  callAutomationScenarioDeleteApi,
  callAutomationScenarioPublishApi,
  callAutomationScenarioDuplicateApi,
  callAutomationScenarioDisableApi,
  callAutomationScenarioStatusListApi,
  callAutomationCanvasApi,
  callAutomationNodeCreateApi,
  callAutomationNodeUpdateApi,
  callAutomationNodeDeleteApi,
  callAutomationLinkCreateApi,
  callAutomationLinkDeleteApi,
  callAutomationBlockConfigFieldsApi,
  callAutomationNodeConfigSaveApi,
  callAutomationNodeConfigDeleteApi,
  callAutomationDelayCreateApi,
  callAutomationDelayUpdateApi,
  callAutomationConditionGroupCreateApi,
  callAutomationConditionGroupUpdateApi,
  callAutomationConditionGroupDeleteApi,
  callAutomationConditionRuleCreateApi,
  callAutomationConditionRuleUpdateApi,
  callAutomationConditionRuleDeleteApi,
  callAutomationExecutionListApi,
  callAutomationExecutionDataApi,
  callAutomationExecutionTriggerApi,
  callAutomationExecutionStatusListApi,
} from "../../helpers/fakebackend_helper";

const errMsg = (error) => error?.message || String(error);

// ── reads ──────────────────────────────────────────────────────────────────
function* scenarioListSaga() {
  try {
    const res = yield call(callAutomationScenarioListApi);
    yield put(automationScenarioListSuccess(res));
  } catch (e) {
    yield put(automationScenarioListFailure(errMsg(e)));
  }
}
function* scenarioStatusListSaga() {
  try {
    const res = yield call(callAutomationScenarioStatusListApi);
    yield put(automationScenarioStatusListSuccess(res));
  } catch (e) {
    yield put(automationScenarioStatusListFailure(errMsg(e)));
  }
}
function* canvasSaga({ payload }) {
  try {
    const res = yield call(callAutomationCanvasApi, payload);
    yield put(automationCanvasSuccess(res));
  } catch (e) {
    yield put(automationCanvasFailure(errMsg(e)));
  }
}
function* blockConfigFieldsSaga({ payload }) {
  try {
    const res = yield call(callAutomationBlockConfigFieldsApi, payload);
    yield put(
      automationBlockConfigFieldsSuccess({
        blockId: payload?.Id ?? payload,
        fields: res,
      })
    );
  } catch (e) {
    yield put(automationBlockConfigFieldsFailure(errMsg(e)));
  }
}
function* executionListSaga({ payload }) {
  try {
    const res = yield call(callAutomationExecutionListApi, payload);
    yield put(automationExecutionListSuccess(res));
  } catch (e) {
    yield put(automationExecutionListFailure(errMsg(e)));
  }
}
function* executionDataSaga({ payload }) {
  try {
    const res = yield call(callAutomationExecutionDataApi, payload);
    yield put(automationExecutionDataSuccess(res));
  } catch (e) {
    yield put(automationExecutionDataFailure(errMsg(e)));
  }
}
function* executionStatusListSaga() {
  try {
    const res = yield call(callAutomationExecutionStatusListApi);
    yield put(automationExecutionStatusListSuccess(res));
  } catch (e) {
    yield put(automationExecutionStatusListFailure(errMsg(e)));
  }
}

// ── scenario lifecycle ───────────────────────────────────────────────────────
function* scenarioCreateSaga({ payload }) {
  try {
    const res = yield call(callAutomationScenarioCreateApi, payload);
    yield put(automationScenarioCreateSuccess(res));
  } catch (e) {
    yield put(automationScenarioCreateFailure(errMsg(e)));
  }
}
function* scenarioUpdateSaga({ payload }) {
  try {
    const res = yield call(callAutomationScenarioUpdateApi, payload);
    yield put(automationScenarioUpdateSuccess(res));
  } catch (e) {
    yield put(automationScenarioUpdateFailure(errMsg(e)));
  }
}
function* scenarioPublishSaga({ payload }) {
  try {
    const res = yield call(callAutomationScenarioPublishApi, payload);
    yield put(automationScenarioPublishSuccess(res));
  } catch (e) {
    yield put(automationScenarioPublishFailure(errMsg(e)));
  }
}
function* scenarioDuplicateSaga({ payload }) {
  try {
    const res = yield call(callAutomationScenarioDuplicateApi, payload);
    yield put(automationScenarioDuplicateSuccess(res));
  } catch (e) {
    yield put(automationScenarioDuplicateFailure(errMsg(e)));
  }
}
function* scenarioDisableSaga({ payload }) {
  try {
    const res = yield call(callAutomationScenarioDisableApi, payload);
    yield put(automationScenarioDisableSuccess(res));
  } catch (e) {
    yield put(automationScenarioDisableFailure(errMsg(e)));
  }
}
function* scenarioDeleteSaga({ payload }) {
  try {
    const res = yield call(callAutomationScenarioDeleteApi, payload);
    yield put(automationScenarioDeleteSuccess(res));
  } catch (e) {
    yield put(automationScenarioDeleteFailure(errMsg(e)));
  }
}

// ── nodes ────────────────────────────────────────────────────────────────────
function* nodeCreateSaga({ payload }) {
  try {
    const res = yield call(callAutomationNodeCreateApi, payload);
    yield put(automationNodeCreateSuccess(res));
  } catch (e) {
    yield put(automationNodeCreateFailure(errMsg(e)));
  }
}
function* nodeUpdateSaga({ payload }) {
  try {
    const res = yield call(callAutomationNodeUpdateApi, payload);
    yield put(automationNodeUpdateSuccess(res));
  } catch (e) {
    yield put(automationNodeUpdateFailure(errMsg(e)));
  }
}
function* nodeDeleteSaga({ payload }) {
  try {
    const res = yield call(callAutomationNodeDeleteApi, payload);
    yield put(automationNodeDeleteSuccess(res));
  } catch (e) {
    yield put(automationNodeDeleteFailure(errMsg(e)));
  }
}

// ── links ────────────────────────────────────────────────────────────────────
function* linkCreateSaga({ payload }) {
  try {
    const res = yield call(callAutomationLinkCreateApi, payload);
    yield put(automationLinkCreateSuccess(res));
  } catch (e) {
    yield put(automationLinkCreateFailure(errMsg(e)));
  }
}
function* linkDeleteSaga({ payload }) {
  try {
    const res = yield call(callAutomationLinkDeleteApi, payload);
    yield put(automationLinkDeleteSuccess(res));
  } catch (e) {
    yield put(automationLinkDeleteFailure(errMsg(e)));
  }
}

// ── node config ──────────────────────────────────────────────────────────────
function* nodeConfigSaveSaga({ payload }) {
  try {
    const res = yield call(callAutomationNodeConfigSaveApi, payload);
    yield put(automationNodeConfigSaveSuccess(res));
  } catch (e) {
    yield put(automationNodeConfigSaveFailure(errMsg(e)));
  }
}
function* nodeConfigDeleteSaga({ payload }) {
  try {
    const res = yield call(callAutomationNodeConfigDeleteApi, payload);
    yield put(automationNodeConfigDeleteSuccess(res));
  } catch (e) {
    yield put(automationNodeConfigDeleteFailure(errMsg(e)));
  }
}

// ── delay ────────────────────────────────────────────────────────────────────
function* delayCreateSaga({ payload }) {
  try {
    const res = yield call(callAutomationDelayCreateApi, payload);
    yield put(automationDelayCreateSuccess(res));
  } catch (e) {
    yield put(automationDelayCreateFailure(errMsg(e)));
  }
}
function* delayUpdateSaga({ payload }) {
  try {
    const res = yield call(callAutomationDelayUpdateApi, payload);
    yield put(automationDelayUpdateSuccess(res));
  } catch (e) {
    yield put(automationDelayUpdateFailure(errMsg(e)));
  }
}

// ── condition group ──────────────────────────────────────────────────────────
function* conditionGroupCreateSaga({ payload }) {
  try {
    const res = yield call(callAutomationConditionGroupCreateApi, payload);
    yield put(automationConditionGroupCreateSuccess(res));
  } catch (e) {
    yield put(automationConditionGroupCreateFailure(errMsg(e)));
  }
}
function* conditionGroupUpdateSaga({ payload }) {
  try {
    const res = yield call(callAutomationConditionGroupUpdateApi, payload);
    yield put(automationConditionGroupUpdateSuccess(res));
  } catch (e) {
    yield put(automationConditionGroupUpdateFailure(errMsg(e)));
  }
}
function* conditionGroupDeleteSaga({ payload }) {
  try {
    const res = yield call(callAutomationConditionGroupDeleteApi, payload);
    yield put(automationConditionGroupDeleteSuccess(res));
  } catch (e) {
    yield put(automationConditionGroupDeleteFailure(errMsg(e)));
  }
}

// ── condition rule ───────────────────────────────────────────────────────────
function* conditionRuleCreateSaga({ payload }) {
  try {
    const res = yield call(callAutomationConditionRuleCreateApi, payload);
    yield put(automationConditionRuleCreateSuccess(res));
  } catch (e) {
    yield put(automationConditionRuleCreateFailure(errMsg(e)));
  }
}
function* conditionRuleUpdateSaga({ payload }) {
  try {
    const res = yield call(callAutomationConditionRuleUpdateApi, payload);
    yield put(automationConditionRuleUpdateSuccess(res));
  } catch (e) {
    yield put(automationConditionRuleUpdateFailure(errMsg(e)));
  }
}
function* conditionRuleDeleteSaga({ payload }) {
  try {
    const res = yield call(callAutomationConditionRuleDeleteApi, payload);
    yield put(automationConditionRuleDeleteSuccess(res));
  } catch (e) {
    yield put(automationConditionRuleDeleteFailure(errMsg(e)));
  }
}

// ── execution trigger ────────────────────────────────────────────────────────
function* executionTriggerSaga({ payload }) {
  try {
    const res = yield call(callAutomationExecutionTriggerApi, payload);
    yield put(automationExecutionTriggerSuccess(res));
  } catch (e) {
    yield put(automationExecutionTriggerFailure(errMsg(e)));
  }
}

export default function* automationSaga() {
  yield all([
    takeLatest(AUTOMATION_SCENARIO_LIST, scenarioListSaga),
    takeLatest(AUTOMATION_SCENARIO_STATUS_LIST, scenarioStatusListSaga),
    takeLatest(AUTOMATION_CANVAS, canvasSaga),
    takeEvery(AUTOMATION_BLOCK_CONFIG_FIELDS, blockConfigFieldsSaga),
    takeLatest(AUTOMATION_EXECUTION_LIST, executionListSaga),
    takeLatest(AUTOMATION_EXECUTION_DATA, executionDataSaga),
    takeLatest(AUTOMATION_EXECUTION_STATUS_LIST, executionStatusListSaga),

    takeLatest(AUTOMATION_SCENARIO_CREATE, scenarioCreateSaga),
    takeLatest(AUTOMATION_SCENARIO_UPDATE, scenarioUpdateSaga),
    takeLatest(AUTOMATION_SCENARIO_PUBLISH, scenarioPublishSaga),
    takeLatest(AUTOMATION_SCENARIO_DUPLICATE, scenarioDuplicateSaga),
    takeLatest(AUTOMATION_SCENARIO_DISABLE, scenarioDisableSaga),
    takeLatest(AUTOMATION_SCENARIO_DELETE, scenarioDeleteSaga),

    takeEvery(AUTOMATION_NODE_CREATE, nodeCreateSaga),
    takeEvery(AUTOMATION_NODE_UPDATE, nodeUpdateSaga),
    takeEvery(AUTOMATION_NODE_DELETE, nodeDeleteSaga),

    takeEvery(AUTOMATION_LINK_CREATE, linkCreateSaga),
    takeEvery(AUTOMATION_LINK_DELETE, linkDeleteSaga),

    takeEvery(AUTOMATION_NODE_CONFIG_SAVE, nodeConfigSaveSaga),
    takeEvery(AUTOMATION_NODE_CONFIG_DELETE, nodeConfigDeleteSaga),

    takeEvery(AUTOMATION_DELAY_CREATE, delayCreateSaga),
    takeEvery(AUTOMATION_DELAY_UPDATE, delayUpdateSaga),

    takeEvery(AUTOMATION_CONDITION_GROUP_CREATE, conditionGroupCreateSaga),
    takeEvery(AUTOMATION_CONDITION_GROUP_UPDATE, conditionGroupUpdateSaga),
    takeEvery(AUTOMATION_CONDITION_GROUP_DELETE, conditionGroupDeleteSaga),

    takeEvery(AUTOMATION_CONDITION_RULE_CREATE, conditionRuleCreateSaga),
    takeEvery(AUTOMATION_CONDITION_RULE_UPDATE, conditionRuleUpdateSaga),
    takeEvery(AUTOMATION_CONDITION_RULE_DELETE, conditionRuleDeleteSaga),

    takeLatest(AUTOMATION_EXECUTION_TRIGGER, executionTriggerSaga),
  ]);
}
